export default __webpack_public_path__ + "static/media/slide1.ea7ad168.jpg";